import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DsSurgeArrestorIP, MultiOptDetails_3DS, OptionsConnectedDef, SaveEventType, SaveStatusObj, SOModule, UserType, ValidationItem, ValidationSummary } from '../../../../shared/misc-classes';
import { DataService } from '../../../../shared/dataservice.service';
import { ValidationDialog } from '../../../../dialogs/validation-dialog/validation-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ds-surge-arrestor',
  templateUrl: './ds-surge-arrestor.component.html',
  styleUrls: ['./ds-surge-arrestor.component.css']
})
export class DsSurgeArrestorComponent implements OnInit, OnChanges {

  @Input() dsSurgeArrestorObj: DsSurgeArrestorIP;
  @Input() soLockObtained: boolean;
  @Input() accessLevel: Array<UserType>;
  @Output() updateDatasheet: EventEmitter<SaveStatusObj> = new EventEmitter();

  disableForm: boolean = false;
  inputDisableMessage: string = 'This form is not yet enabled';
  readonlyAccess: boolean = false;
  Hvr: any = {};
  hasAccessEE: boolean = false;
  hasAccessME: boolean = false;
  hasAccessPM: boolean = false;
  lockFields: boolean = false; // After HOM lock

  constructor(public _dataService: DataService, public dialog: MatDialog) { }

  ngOnInit(): void {
  }
  ngOnChanges(): void {
    this.disableForm = true;
    if (this.soLockObtained == false) {
      this.inputDisableMessage = "You can't Edit";
    }
    else if (this.accessLevel.includes(this._dataService.userType) == false) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false;
      // this.checkUserEnabled();
    }
    if (this._dataService.hasReadOnlyAccess) {
      this.readonlyAccess = true;
    }
    this.hasAccessEE = this._dataService.userType === (UserType.ELECTRICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    this.hasAccessME = this._dataService.userType === (UserType.MECHANICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    this.hasAccessPM = this._dataService.userType === (UserType.PROJECT_MANAGEMENT) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    if (!this.dsSurgeArrestorObj.parentSORef.isDatasheetSubOrderEnabled) {
      this.lockFields = false;
    }
    else {
      this.lockFields = true;
    }

  }

  addNewSurgArrBlock() {
    this.dsSurgeArrestorObj.addSurgArrDS(new MultiOptDetails_3DS("", "", ""));
  }
  removeSurgArrBlock(_srDS: MultiOptDetails_3DS) {
    if (_srDS) {
      this.dsSurgeArrestorObj.removeSurgArrDS(_srDS);
    }
  }

  onApplicabilityChange(_srM): boolean {
    if(!_srM.type2 || _srM.type2 == "001") { // When type2 is 'Applicable'
      return true;
    }
    else{
      _srM.type3 = "";
      return false;
    }
  }

  cachedSurgAr: any = {};
  filterSurgAr(_id: string) {
    if (this.cachedSurgAr[_id] != null) {
      return this.cachedSurgAr[_id];
    }
    this.cachedSurgAr[_id] = this._dataService.surgeArr.filter((_obj: OptionsConnectedDef) => {
      if ((_obj.connectedOptionId.length == 0) || _obj.connectedOptionId.indexOf(_id) >= 0) {
        return true;
      }
      return false;
    });
    // return this.cachedSurgAr[_id];
    if (this.cachedSurgAr[_id] != null) {
      return this.cachedSurgAr[_id];
    }
    var _result = !this._dataService.isGeneralSurgeArr(_id);
    this.cachedSurgAr[_id] = _result;
    return _result;
  }

 sectionNoteChangePM(_event: any) {
    this.dsSurgeArrestorObj.sectionNotePM = _event.target.value;
  }
  sectionNoteChangeEE(_event: any) {
    this.dsSurgeArrestorObj.sectionNoteEE = _event.target.value;
  }
  sectionNoteChangeME(_event: any) {
    this.dsSurgeArrestorObj.sectionNoteME = _event.target.value;
  }

  saveDS(_submitToNextSection: boolean) {
    if (this.updateDatasheet) {
      this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing,
        (_submitToNextSection == true ? SaveEventType.Submit_To_Next : SaveEventType.Save_Data)));
    }
  }
  reloadData() {
    if (this.updateDatasheet) {
      this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Reload_Data));
    }
  }

  showSoValidation() {
    let _validList: Array<ValidationItem> = [];

    if (this.hasAccessEE) {
      // for (let i = 0; i < this.dsSurgeArrestorObj.surgeArr.length; i++) {
      //   let sr = this.dsSurgeArrestorObj.surgeArr[i];
      //   _validList.push(
      //     new ValidationItem("Surge Arrestor #" + (i + 1), !!sr.type1, " required to save Datasheet."),
      //     new ValidationItem("Applicability #" + (i + 1), !!sr.type2, " required to save Datasheet.")
      //   );
      //   if (sr.type2 == "001") {
      //     _validList.push(new ValidationItem("Class #" + (i + 1), !!sr.type3, " required to save Datasheet."));
      //   }
      // }
      _validList.push(new ValidationItem("EE Note", !!this.dsSurgeArrestorObj.sectionNoteEE, " required to save Datasheet."));
    }
    if (this.hasAccessPM) {
      _validList.push(new ValidationItem("PM Note", !!this.dsSurgeArrestorObj.sectionNotePM, " required to save Datasheet."));
    }
    if (this.hasAccessME) {
      _validList.push(new ValidationItem("ME Note", !!this.dsSurgeArrestorObj.sectionNoteME, " required to save Datasheet."));
    }

    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    this.dialog.open(ValidationDialog, { width: '50%', data: vSummaryObj });
  }

  saveSOValidation(): boolean {
    if (this.hasAccessEE) {
      // for (let sr of this.dsSurgeArrestorObj.surgeArr) {
      //   if (!sr.type1 || !sr.type2) return false;
      //   if (sr.type2 == "001" && !sr.type3) return false;
      // }
      if (!this.dsSurgeArrestorObj.sectionNoteEE) return false;
    }
    if (this.hasAccessPM) {
      if (!this.dsSurgeArrestorObj.sectionNotePM) return false;
    }
    if (this.hasAccessME) {
      if (!this.dsSurgeArrestorObj.sectionNoteME) return false;
    }
    return true;
  }
}

